export { IMAPOptionsItem as default };

/**
* Imap Options Entity
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class IMAPOptionsItem {
  /**
   * Defines if imap is enabled
   *
   * @public
   *
   * @type {Boolean}
   *
   * @since 7.0.0
   */
  enabled;

  /**
   * Defines if is allowed to enable/disable imap settings
   *
   * @public
   *
   * @type {Boolean}
   *
   * @since 7.0.0
   */
  allowed;
}